// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pagination_pagination__erTU8 {
  background: var(--white);
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid rgba(0, 0, 0, 0.12);
}

.pagination_paginationItem__c7PLx {
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  padding: 8px 14px;
  color: var(--fiord);
  border-radius: 8px;
  text-decoration: none;
  cursor: pointer;
}

.pagination_paginationNumber__7rO8M {
  display: flex;
  gap: 4px;
}

.pagination_pageItem__FZ73- {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 50px;
  height: 40px;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  padding: 10px 16px;
  text-align: center;
}

.pagination_current__Xyt-U,
.pagination_pageItem__FZ73-:hover {
  color: var(--midnightnavy);
  background-color: var(--frostedwhite);
  border-radius: 6px;
}

.pagination_prevButton__b912n,
.pagination_nextButton__p31Dm {
  cursor: pointer;
}

.pagination_prevBtn__El2s6,
.pagination_nextBtn__Xu4hH {
  border: 1px solid var(--lightgrey);
}

.pagination_prevButton__b912n img {
  margin-right: 5px;
}

.pagination_nextButton__p31Dm img {
  rotate: 180deg;
  margin-left: 5px;
}


@media screen and (max-width: 491px) {
  .pagination_pagination__erTU8 button p {
    display: none;
  }

  .pagination_pagination__erTU8 button {
    padding: 10px;
  }

  .pagination_paginationNumber__7rO8M {
        display: flex;
    }
    .pagination_paginationNumber__7rO8M .pagination_paginationItem__c7PLx {
        width: 40px;
        padding: 10px 11px;
    }
}`, "",{"version":3,"sources":["webpack://./src/assets/css/pagination.module.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,+BAA+B;EAC/B,aAAa;EACb,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;;EAEE,0BAA0B;EAC1B,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;;EAEE,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;;AAGA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;QACM,aAAa;IACjB;IACA;QACI,WAAW;QACX,kBAAkB;IACtB;AACJ","sourcesContent":[".pagination {\n  background: var(--white);\n  border-bottom-left-radius: 6px;\n  border-bottom-right-radius: 6px;\n  padding: 20px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-top: 1px solid rgba(0, 0, 0, 0.12);\n}\n\n.paginationItem {\n  display: flex;\n  align-items: center;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 20px;\n  padding: 8px 14px;\n  color: var(--fiord);\n  border-radius: 8px;\n  text-decoration: none;\n  cursor: pointer;\n}\n\n.paginationNumber {\n  display: flex;\n  gap: 4px;\n}\n\n.pageItem {\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  width: 50px;\n  height: 40px;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 20px;\n  padding: 10px 16px;\n  text-align: center;\n}\n\n.current,\n.pageItem:hover {\n  color: var(--midnightnavy);\n  background-color: var(--frostedwhite);\n  border-radius: 6px;\n}\n\n.prevButton,\n.nextButton {\n  cursor: pointer;\n}\n\n.prevBtn,\n.nextBtn {\n  border: 1px solid var(--lightgrey);\n}\n\n.prevButton img {\n  margin-right: 5px;\n}\n\n.nextButton img {\n  rotate: 180deg;\n  margin-left: 5px;\n}\n\n\n@media screen and (max-width: 491px) {\n  .pagination button p {\n    display: none;\n  }\n\n  .pagination button {\n    padding: 10px;\n  }\n\n  .paginationNumber {\n        display: flex;\n    }\n    .paginationNumber .paginationItem {\n        width: 40px;\n        padding: 10px 11px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pagination": `pagination_pagination__erTU8`,
	"paginationItem": `pagination_paginationItem__c7PLx`,
	"paginationNumber": `pagination_paginationNumber__7rO8M`,
	"pageItem": `pagination_pageItem__FZ73-`,
	"current": `pagination_current__Xyt-U`,
	"prevButton": `pagination_prevButton__b912n`,
	"nextButton": `pagination_nextButton__p31Dm`,
	"prevBtn": `pagination_prevBtn__El2s6`,
	"nextBtn": `pagination_nextBtn__Xu4hH`
};
export default ___CSS_LOADER_EXPORT___;
